module.exports = __webpack_public_path__ + "static/media/task.7cc12755.png";